import { createFileRoute } from "@tanstack/react-router";
import HowItWorks from "@/pages/HowItWorks";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/cum-functioneaza/")({
  head: () => routeHead("/cum-functioneaza/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <HowItWorks />
  );
}
